import axios from 'axios'

import {
  AgentAttendanceDetails,
  AgentAttendanceRequestParams,
  AgentAttendanceShiftStatusTimelineResponse,
  AgentAttendanceShort,
  AgentsAttendanceShiftStatusTimelineRequest,
  AgentsAttendanceShortRequest,
  AgentTicketsRequest,
  QueueHealthAnalyticsResponse,
  QueuesHealthDetailsRequestParams,
  QueueStatsFilterRequestParams,
  QueueStatsFilterResponse,
  SpecialisationAttendanceAggregated,
  TicketOutcomesVolumeRequestParams,
  TicketsRequestParams,
  TicketsResponse,
  TicketsVolumeRequestParams,
  VolumeBreakdownResponse,
} from 'modules/Monitoring/types'

export const getTicketsVolume = async (params: TicketsVolumeRequestParams) => {
  return (await axios.post<VolumeBreakdownResponse>('/analytics/tickets/volume', params))
    .data
}

export const getTicketOutcomesVolume = async (
  params: TicketOutcomesVolumeRequestParams,
) => {
  return (await axios.post<VolumeBreakdownResponse>('/analytics/outcomes/volume', params))
    .data
}

export const getAgentAttendanceDetails = async (params: AgentAttendanceRequestParams) => {
  return (
    await axios.post<AgentAttendanceDetails[]>(
      '/analytics/agents/attendance/details',
      params,
    )
  ).data
}

export const getAgentAttendanceShort = async (params: AgentsAttendanceShortRequest) => {
  return (
    await axios.post<AgentAttendanceShort[]>('/analytics/agents/attendance/short', params)
  ).data
}

export const getAgentAttendanceIntervals = async (
  params: AgentAttendanceRequestParams,
) => {
  return (
    await axios.post<SpecialisationAttendanceAggregated[]>(
      '/analytics/agents/attendance/aggregated',
      params,
    )
  ).data
}

export const getAgentAttendanceTimeline = async (
  body: AgentsAttendanceShiftStatusTimelineRequest,
) => {
  return (
    await axios.post<AgentAttendanceShiftStatusTimelineResponse>(
      '/analytics/agents/attendance/shift/status-timeline',
      body,
    )
  ).data
}

export const getQueuesHealthDetails = async (
  params: QueuesHealthDetailsRequestParams,
) => {
  return (
    await axios.post<QueueHealthAnalyticsResponse>('/analytics/queues/details', params)
  ).data
}

export const getTickets = async ({
  filterType,
  queue,
  queueIds,
  specialisation,
  channel,
  filter,
  sortBy,
  page,
}: TicketsRequestParams) => {
  return (
    await axios.post<TicketsResponse>('/analytics/tickets', {
      filterType,
      channel,
      filter,
      sortBy,
      page,
      ...(queueIds?.length && !queue
        ? {
            queueIds,
          }
        : {
            queueId: queue?.id,
            specialisationId: specialisation?.id,
          }),
    })
  ).data
}

export const getAssignedTickets = async (body: AgentTicketsRequest) => {
  return (await axios.post<TicketsResponse>('/analytics/agent-tickets', body)).data
}

export const getQueueStatsFilter = async (params: QueueStatsFilterRequestParams) => {
  return (
    await axios.get<QueueStatsFilterResponse>('/analytics/tickets/queue-stats-filter', {
      params,
    })
  ).data
}

export const getTicketIds = async ({
  filterType,
  queue,
  specialisation,
  channel,
  filter,
  sortBy,
  page,
}: TicketsRequestParams) => {
  return (
    await axios.post<string[]>('/analytics/ticket-ids', {
      filterType,
      channel,
      queueId: queue?.id,
      specialisationId: specialisation?.id,
      filter,
      sortBy,
      page,
    })
  ).data
}

export const getAssignedTicketIds = async (body: AgentTicketsRequest) => {
  return (await axios.post<string[]>('/analytics/agent-ticket-ids', body)).data
}
